import React from "react";

export default function CalendarLoader({ message = "Chargement du calendrier..." }) {
    return (
        <div className="calendar-loader">
            <div className="calendar-loader__spinner" />
            <span>{message}</span>
        </div>
    );
}
